import { Injectable } from '@angular/core';

export type StructureLabelLang = 'es' | 'en' | 'ca' | 'ga' | 'va';

export type StructureLabelKey =
  | 'itinerariesGroups'
  | 'itineraries'
  | 'simpleItineraries'
  | 'nestedItineraries'
  | 'checkpoints'
  | 'pointInterest'
  | 'cities'
  | 'services'
  | 'tourismPosts'
  | 'events'
  | 'navigationTouristResources'
  | 'simpleResource'
  | 'resourceLinks'
  | 'contactInfo'
  | 'puntosControl'
  | 'beacons'
  | 'pantallasSenderos'
  | 'screen_view'
  | 'app_startup'
  | 'menu_interaction'
  | 'form_submission'
  | 'content_feedback'
  | 'registroUsuarios'
  | 'gamificacion'
  | 'usuarios'
  | 'dispositivos'
  | 'screens'
  | 'forms'
  | 'menu_buttons';

const DEFAULT_LANG: StructureLabelLang = 'es';

const STRUCTURE_LABELS: Record<StructureLabelKey, Record<StructureLabelLang, string>> = {
  itinerariesGroups: {
    es: 'Área Protegida',
    en: 'Protected Area',
    ca: 'Àrea Protegida',
    ga: 'Área Protexida',
    va: 'Àrea Protegida'
  },
  itineraries: {
    es: 'Sendero',
    en: 'Trail',
    ca: 'Sender',
    ga: 'Sendeiro',
    va: 'Sender'
  },
  checkpoints: {
    es: 'Puntos de control',
    en: 'Checkpoints',
    ca: 'Punts de control',
    ga: 'Puntos de control',
    va: 'Punts de control'
  },
  pointInterest: {
    es: 'Puntos de interés',
    en: 'Points of interest',
    ca: "Punts d'interès",
    ga: 'Puntos de interese',
    va: "Punts d'interés"
  },
  puntosControl: {
    es: 'Puntos de control',
    en: 'Checkpoints',
    ca: 'Punts de control',
    ga: 'Puntos de control',
    va: 'Punts de control'
  },
  beacons: {
    es: 'Beacons',
    en: 'Beacons',
    ca: 'Beacons',
    ga: 'Beacons',
    va: 'Beacons'
  },
  pantallasSenderos: {
    es: 'Visualizaciones',
    en: 'Views',
    ca: 'Visualitzacions',
    ga: 'Visualizacións',
    va: 'Visualitzacions'
  },
  screen_view: {
    es: 'Pantallas vistas',
    en: 'Screen views',
    ca: 'Pantalles vistes',
    ga: 'Pantallas vistas',
    va: 'Pantalles vistes'
  },
  cities: {
    es: 'Ciudades',
    en: 'Cities',
    ca: 'Ciutats',
    ga: 'Cidades',
    va: 'Ciutats'
  },
  simpleItineraries: {
    es: 'Itinerarios simples',
    en: 'Simple trails',
    ca: 'Itineraris simples',
    ga: 'Itinerarios simples',
    va: 'Itineraris simples'
  },
  nestedItineraries: {
    es: 'Itinerarios anidados',
    en: 'Nested trails',
    ca: 'Itineraris imbricats',
    ga: 'Itinerarios aniñados',
    va: 'Itineraris imbricats'
  },
  services: {
    es: 'Servicios',
    en: 'Services',
    ca: 'Serveis',
    ga: 'Servizos',
    va: 'Servicis'
  },
  tourismPosts: {
    es: 'Publicaciones turísticas',
    en: 'Tourism posts',
    ca: 'Publicacions turístiques',
    ga: 'Publicacións turísticas',
    va: 'Publicacions turístiques'
  },
  events: {
    es: 'Eventos',
    en: 'Events',
    ca: 'Esdeveniments',
    ga: 'Eventos',
    va: 'Esdeveniments'
  },
  navigationTouristResources: {
    es: 'Recursos turísticos',
    en: 'Tourist resources',
    ca: 'Recursos turístics',
    ga: 'Recursos turísticos',
    va: 'Recursos turístics'
  },
  simpleResource: {
    es: 'Recurso',
    en: 'Resource',
    ca: 'Recurs',
    ga: 'Recurso',
    va: 'Recurs'
  },
  resourceLinks: {
    es: 'Enlaces de recurso',
    en: 'Resource links',
    ca: 'Enllaços de recurs',
    ga: 'Ligazóns de recurso',
    va: 'Enllaços de recurs'
  },
  contactInfo: {
    es: 'Información de contacto',
    en: 'Contact info',
    ca: 'Informació de contacte',
    ga: 'Información de contacto',
    va: 'Informació de contacte'
  },
  app_startup: {
    es: 'Funnel de arranque',
    en: 'Startup funnel',
    ca: "Embut d'arrencada",
    ga: 'Funil de arranque',
    va: "Embut d'arrancada"
  },
  menu_interaction: {
    es: 'Interacción de menú',
    en: 'Menu interaction',
    ca: 'Interacció de menú',
    ga: 'Interacción de menú',
    va: 'Interacció de menú'
  },
  form_submission: {
    es: 'Formularios',
    en: 'Forms',
    ca: 'Formularis',
    ga: 'Formularios',
    va: 'Formularis'
  },
  content_feedback: {
    es: 'Feedback de contenido',
    en: 'Content feedback',
    ca: 'Feedback de contingut',
    ga: 'Feedback de contido',
    va: 'Feedback de contingut'
  },
  registroUsuarios: {
    es: 'Usuarios',
    en: 'Users',
    ca: 'Usuaris',
    ga: 'Usuarios',
    va: 'Usuaris'
  },
  gamificacion: {
    es: 'Gamificación',
    en: 'Gamification',
    ca: 'Gamificació',
    ga: 'Gamificación',
    va: 'Gamificació'
  },
  usuarios: {
    es: 'Usuarios',
    en: 'Users',
    ca: 'Usuaris',
    ga: 'Usuarios',
    va: 'Usuaris'
  },
  dispositivos: {
    es: 'Dispositivos',
    en: 'Devices',
    ca: 'Dispositius',
    ga: 'Dispositivos',
    va: 'Dispositius'
  },
  screens: {
    es: 'Pantallas',
    en: 'Screens',
    ca: 'Pantalles',
    ga: 'Pantallas',
    va: 'Pantalles'
  },
  forms: {
    es: 'Formularios',
    en: 'Forms',
    ca: 'Formularis',
    ga: 'Formularios',
    va: 'Formularis'
  },
  menu_buttons: {
    es: 'Botones del menú',
    en: 'Menu buttons',
    ca: 'Botons del menú',
    ga: 'Botóns do menú',
    va: 'Botons del menú'
  }
};

const SUBTYPE_LABELS: Record<string, Record<string, Record<StructureLabelLang, string>>> = {
  pantallasSenderos: {
    visualizacion: {
      es: 'Visualizaciones', en: 'Views', ca: 'Visualitzacions', ga: 'Visualizacións', va: 'Visualitzacions'
    },
    descarga_offline: {
      es: 'Descargas offline', en: 'Offline downloads', ca: 'Descàrregues offline', ga: 'Descargas offline', va: 'Descàrregues offline'
    },
    seleccion_mapa: {
      es: 'Selección en mapa', en: 'Map selection', ca: 'Selecció al mapa', ga: 'Selección no mapa', va: 'Selecció al mapa'
    },
    abrir_desde_mapa: {
      es: 'Apertura desde mapa', en: 'Opened from map', ca: 'Obertura des del mapa', ga: 'Apertura desde mapa', va: 'Obertura des del mapa'
    },
    ver_mapa: {
      es: 'Ver mapa', en: 'View map', ca: 'Veure mapa', ga: 'Ver mapa', va: 'Veure mapa'
    },
    abrir_google_maps: {
      es: 'Abrir Google Maps', en: 'Open Google Maps', ca: 'Obrir Google Maps', ga: 'Abrir Google Maps', va: 'Obrir Google Maps'
    },
    ver_galeria: {
      es: 'Ver galería', en: 'View gallery', ca: 'Veure galeria', ga: 'Ver galería', va: 'Veure galeria'
    },
    reproducir_audioguia: {
      es: 'Reproducir audioguía', en: 'Play audio guide', ca: 'Reproduir audioguia', ga: 'Reproducir audioguía', va: 'Reproduir audioguia'
    },
    pausar_audioguia: {
      es: 'Pausar audioguía', en: 'Pause audio guide', ca: 'Pausar audioguia', ga: 'Pausar audioguía', va: 'Pausar audioguia'
    }
  },
  screen_view: {
    home: {
      es: 'Inicio', en: 'Home', ca: 'Inici', ga: 'Inicio', va: 'Inici'
    },
    mapa: {
      es: 'Mapa', en: 'Map', ca: 'Mapa', ga: 'Mapa', va: 'Mapa'
    },
    map: {
      es: 'Mapa', en: 'Map', ca: 'Mapa', ga: 'Mapa', va: 'Mapa'
    },
    itineraries: {
      es: 'Senderos', en: 'Trails', ca: 'Senders', ga: 'Sendeiros', va: 'Senders'
    },
    pointInterest: {
      es: 'Puntos de interés', en: 'Points of interest', ca: "Punts d'interès", ga: 'Puntos de interese', va: "Punts d'interés"
    },
    posts: {
      es: 'Publicaciones', en: 'Posts', ca: 'Publicacions', ga: 'Publicacións', va: 'Publicacions'
    },
    services: {
      es: 'Servicios', en: 'Services', ca: 'Serveis', ga: 'Servizos', va: 'Servicis'
    },
    events: {
      es: 'Eventos', en: 'Events', ca: 'Esdeveniments', ga: 'Eventos', va: 'Esdeveniments'
    }
  },
  puntosControl: {
    punto_control_guardado: {
      es: 'Checkpoint guardado', en: 'Checkpoint saved', ca: 'Checkpoint desat', ga: 'Checkpoint gardado', va: 'Checkpoint guardat'
    },
    sendero_completado: {
      es: 'Sendero completado', en: 'Trail completed', ca: 'Sender completat', ga: 'Cosáin completado', va: 'Senda completat'
    }
  },
  beacons: {
    beacon_detectado: {
      es: 'Beacon detectado', en: 'Beacon detected', ca: 'Balisa detectada', ga: 'Beacon detectado', va: 'Balisa detectada'
    },
    configuracion_activada: {
      es: 'Config. activada', en: 'Config. activated', ca: 'Config. activada', ga: 'Config. activada', va: 'Config. activada'
    },
    notificacion_enviada: {
      es: 'Notif. enviada', en: 'Notif. sent', ca: 'Notif. enviada', ga: 'Notif. enviada', va: 'Notif. enviada'
    },
    notificacion_abierta: {
      es: 'Notif. abierta', en: 'Notif. opened', ca: 'Notif. oberta', ga: 'Notif. aberta', va: 'Notif. oberta'
    }
  },
  app_startup: {
    app_start: {
      es: 'Inicio de app', en: 'App start', ca: "Inici d'app", ga: 'Inicio de app', va: "Inici d'app"
    },
    bienvenida: {
      es: 'Bienvenida', en: 'Welcome', ca: 'Benvinguda', ga: 'Benvida', va: 'Benvinguda'
    },
    permisos_entrada: {
      es: 'Entrada a permisos', en: 'Permissions entry', ca: 'Entrada a permisos', ga: 'Entrada a permisos', va: 'Entrada a permisos'
    },
    permisos_fase_informativa: {
      es: 'Fase informativa', en: 'Info phase', ca: 'Fase informativa', ga: 'Fase informativa', va: 'Fase informativa'
    },
    permisos_location_denegado: {
      es: 'Ubicación denegada', en: 'Location denied', ca: 'Ubicació denegada', ga: 'Localización denegada', va: 'Ubicació denegada'
    },
    permisos_location_bloqueado: {
      es: 'Ubicación bloqueada', en: 'Location blocked', ca: 'Ubicació bloquejada', ga: 'Localización bloqueada', va: 'Ubicació bloquejada'
    },
    permisos_location_precision_reducida: {
      es: 'Precisión reducida', en: 'Reduced accuracy', ca: 'Precisió reduïda', ga: 'Precisión reducida', va: 'Precisió reduïda'
    },
    permisos_location_background_denegado: {
      es: 'Ubicación 2.º plano denegada', en: 'Background location denied', ca: 'Ubicació 2n pla denegada', ga: 'Localización 2.º plano denegada', va: 'Ubicació 2n pla denegada'
    },
    permisos_location_background_bloqueado: {
      es: 'Ubicación 2.º plano bloqueada', en: 'Background location blocked', ca: 'Ubicació 2n pla bloquejada', ga: 'Localización 2.º plano bloqueada', va: 'Ubicació 2n pla bloquejada'
    },
    permisos_bluetooth_denegado: {
      es: 'Bluetooth denegado', en: 'Bluetooth denied', ca: 'Bluetooth denegat', ga: 'Bluetooth denegado', va: 'Bluetooth denegat'
    },
    permisos_bluetooth_bloqueado: {
      es: 'Bluetooth bloqueado', en: 'Bluetooth blocked', ca: 'Bluetooth bloquejat', ga: 'Bluetooth bloqueado', va: 'Bluetooth bloquejat'
    },
    permisos_notificacion_denegada: {
      es: 'Notif. denegadas', en: 'Notifications denied', ca: 'Notif. denegades', ga: 'Notif. denegadas', va: 'Notif. denegades'
    },
    permisos_notificacion_bloqueada: {
      es: 'Notif. bloqueadas', en: 'Notifications blocked', ca: 'Notif. bloquejades', ga: 'Notif. bloqueadas', va: 'Notif. bloquejades'
    },
    permisos_beacons_desactivados: {
      es: 'Beacons desactivados', en: 'Beacons disabled', ca: 'Beacons desactivats', ga: 'Beacons desactivados', va: 'Beacons desactivats'
    },
    permisos_completados_con_beacons: {
      es: 'Completado con beacons', en: 'Completed with beacons', ca: 'Completat amb beacons', ga: 'Completado con beacons', va: 'Completat amb beacons'
    },
    permisos_completados_sin_beacons: {
      es: 'Completado sin beacons', en: 'Completed without beacons', ca: 'Completat sense beacons', ga: 'Completado sen beacons', va: 'Completat sense beacons'
    },
    permisos_completados: {
      es: 'Permisos completados', en: 'Permissions completed', ca: 'Permisos completats', ga: 'Permisos completados', va: 'Permisos completats'
    },
    menu_principal: {
      es: 'Menú principal', en: 'Main menu', ca: 'Menú principal', ga: 'Menú principal', va: 'Menú principal'
    }
  },
  menu_interaction: {
    tap: {
      es: 'Pulsación', en: 'Tap', ca: 'Pulsació', ga: 'Pulsación', va: 'Pulsació'
    },
    idioma: {
      es: 'Cambio de idioma', en: 'Language change', ca: "Canvi d'idioma", ga: 'Cambio de idioma', va: "Canvi d'idioma"
    },
    enlace_externo: {
      es: 'Enlace externo', en: 'External link', ca: 'Enllaç extern', ga: 'Ligazón externa', va: 'Enllaç extern'
    }
  },
  form_submission: {
    form_open: {
      es: 'Apertura', en: 'Opened', ca: 'Obertura', ga: 'Apertura', va: 'Obertura'
    },
    form_submit_success: {
      es: 'Envío exitoso', en: 'Sent successfully', ca: 'Enviament exitós', ga: 'Envío exitoso', va: 'Enviament exitós'
    },
    form_submit_error: {
      es: 'Error de envío', en: 'Send error', ca: "Error d'enviament", ga: 'Erro de envío', va: "Error d'enviament"
    },
    descarga_datos_usuario: {
      es: 'Descarga de datos de usuario', en: 'User data export', ca: "Descàrrega de dades d'usuari", ga: 'Descarga de datos de usuario', va: "Descàrrega de dades d'usuari"
    }
  },
  registroUsuarios: {
    usuario_anonimo_abre_app_por_primera_vez: {
      es: 'Usuario anónimo abre la app', en: 'Anonymous user opens app', ca: "Usuari anònim obri l'app", ga: 'Usuario anónimo abre a app', va: "Usuari anònim obri l'app"
    },
    usuario_se_registra: {
      es: 'Registro', en: 'Registration', ca: 'Registre', ga: 'Rexistro', va: 'Registre'
    },
    login: {
      es: 'Login', en: 'Login', ca: 'Login', ga: 'Login', va: 'Login'
    },
    logout: {
      es: 'Logout', en: 'Logout', ca: 'Logout', ga: 'Logout', va: 'Logout'
    },
    borrar_cuenta: {
      es: 'Borrado de cuenta', en: 'Account deletion', ca: 'Eliminació de compte', ga: 'Borrado de conta', va: 'Eliminació de compte'
    }
  },
  gamificacion: {
    rango_alcanzado: {
      es: 'Rango alcanzado', en: 'Rank reached', ca: 'Rang assolit', ga: 'Rango acadado', va: 'Rang assolit'
    },
    logro_desbloqueado: {
      es: 'Logro desbloqueado', en: 'Achievement unlocked', ca: 'Assoliment desbloquejat', ga: 'Logro desbloqueado', va: 'Assoliment desbloquejat'
    }
  },
  content_feedback: {
    incidencia_form_open: {
      es: 'Incidencia abierta', en: 'Issue opened', ca: 'Incidència oberta', ga: 'Incidencia aberta', va: 'Incidència oberta'
    },
    incidencia_form_submit_success: {
      es: 'Incidencia enviada', en: 'Issue sent', ca: 'Incidència enviada', ga: 'Incidencia enviada', va: 'Incidència enviada'
    },
    incidencia_form_submit_error: {
      es: 'Error en incidencia', en: 'Issue send error', ca: 'Error en incidència', ga: 'Erro en incidencia', va: 'Error en incidència'
    },
    contacto_form_open: {
      es: 'Contacto abierto', en: 'Contact opened', ca: 'Contacte obert', ga: 'Contacto aberto', va: 'Contacte obert'
    },
    contacto_form_submit_success: {
      es: 'Contacto enviado', en: 'Contact sent', ca: 'Contacte enviat', ga: 'Contacto enviado', va: 'Contacte enviat'
    },
    contacto_form_submit_error: {
      es: 'Error en contacto', en: 'Contact send error', ca: 'Error en contacte', ga: 'Erro en contacto', va: 'Error en contacte'
    }
  }
};

@Injectable({
  providedIn: 'root'
})
export class StructureLabelsService {
  getLabel(key: string, language: string, fallbackLanguage: StructureLabelLang = DEFAULT_LANG): string {
    const labels = STRUCTURE_LABELS[key as StructureLabelKey];
    if (!labels) {
      return key;
    }

    const lang = this.normalizeLanguage(language);
    return labels[lang] || labels[fallbackLanguage] || key;
  }

  getLabelsForLanguage(language: string, fallbackLanguage: StructureLabelLang = DEFAULT_LANG): Record<StructureLabelKey, string> {
    const lang = this.normalizeLanguage(language);

    return Object.keys(STRUCTURE_LABELS).reduce((acc, key) => {
      const typedKey = key as StructureLabelKey;
      acc[typedKey] = STRUCTURE_LABELS[typedKey][lang] || STRUCTURE_LABELS[typedKey][fallbackLanguage];
      return acc;
    }, {} as Record<StructureLabelKey, string>);
  }

  getSubtypeLabel(metricType: string, subtype: string, language: string, fallbackLanguage: StructureLabelLang = DEFAULT_LANG): string {
    const labels = SUBTYPE_LABELS[metricType]?.[subtype];
    if (!labels) {
      return subtype;
    }
    const lang = this.normalizeLanguage(language);
    return labels[lang] || labels[fallbackLanguage] || subtype;
  }

  private normalizeLanguage(language: string): StructureLabelLang {
    const normalized = (language || DEFAULT_LANG).toLowerCase().split('-')[0] as StructureLabelLang;
    const supportedLanguages: StructureLabelLang[] = ['es', 'en', 'ca', 'ga', 'va'];
    return supportedLanguages.includes(normalized) ? normalized : DEFAULT_LANG;
  }
}
